module.exports = __webpack_public_path__ + "img/jyServiceItem4.7976f2e7.png";